import { useEffect, useState } from "react";
import { getAllConnectionRuntimeConfigs } from "../services/connectionRuntimeConfig";

interface IUseFetchAllConnectionRuntimeConfigs {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  shouldFetch?: boolean;
}

const useFetchAllConnectionRuntimeConfigs = ({
  setIsLoading,
  shouldFetch = false,
}: IUseFetchAllConnectionRuntimeConfigs) => {
  const [connectionRuntimeConfigs, setConnectionRuntimeConfigs] = useState<
    any[]
  >([]);

  useEffect(() => {
    // Only fetch if shouldFetch is true
    if (!shouldFetch) {
      setConnectionRuntimeConfigs([]);
      return;
    }

    const getConnectionRuntimeConfigsData = async () => {
      setIsLoading(true);
      try {
        const result = await getAllConnectionRuntimeConfigs();
        setConnectionRuntimeConfigs(result);
      } catch (err) {
        console.error("Error fetching connection runtime configs:", err);
        setConnectionRuntimeConfigs([]);
      } finally {
        setIsLoading(false);
      }
    };

    getConnectionRuntimeConfigsData();
  }, [shouldFetch, setIsLoading]);

  return [connectionRuntimeConfigs];
};

export default useFetchAllConnectionRuntimeConfigs;

